module.exports = __webpack_public_path__ + "img/mank-dika.5a4903cd.jpg";